<template>
  <v-dialog
    :value="value"
    max-width="600"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title>
        <h4 class="primary--text">{{ $t('tslOrders.filter.title') }}</h4>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <h5 class="subtitle-2 mb-2">{{ $t('tslOrders.filter.orderCreationDate') }}</h5>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu
              v-model="dateFromMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="localFilters.dateFrom"
                  :label="$t('tslOrders.filter.dateFrom')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="localFilters.dateFrom = null"
                />
              </template>
              <v-date-picker
                v-model="localFilters.dateFrom"
                @input="dateFromMenu = false"
                :max="localFilters.dateTo"
              />
            </v-menu>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu
              v-model="dateToMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="localFilters.dateTo"
                  :label="$t('tslOrders.filter.dateTo')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="localFilters.dateTo = null"
                />
              </template>
              <v-date-picker
                v-model="localFilters.dateTo"
                @input="dateToMenu = false"
                :min="localFilters.dateFrom"
              />
            </v-menu>
          </v-col>
        </v-row>

        <v-divider class="my-4" />

        <v-row>
          <v-col cols="12">
            <h5 class="subtitle-2 mb-2">{{ $t('tslOrders.filter.loadingDate') }}</h5>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu
              v-model="loadingDateFromMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="localFilters.loadingDateFrom"
                  :label="$t('tslOrders.filter.dateFrom')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="localFilters.loadingDateFrom = null"
                />
              </template>
              <v-date-picker
                v-model="localFilters.loadingDateFrom"
                @input="loadingDateFromMenu = false"
                :max="localFilters.loadingDateTo"
              />
            </v-menu>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu
              v-model="loadingDateToMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="localFilters.loadingDateTo"
                  :label="$t('tslOrders.filter.dateTo')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="localFilters.loadingDateTo = null"
                />
              </template>
              <v-date-picker
                v-model="localFilters.loadingDateTo"
                @input="loadingDateToMenu = false"
                :min="localFilters.loadingDateFrom"
              />
            </v-menu>
          </v-col>
        </v-row>

        <v-divider class="my-4" />

        <v-row>
          <v-col cols="12">
            <h5 class="subtitle-2 mb-2">{{ $t('tslOrders.filter.unloadingDate') }}</h5>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu
              v-model="unloadingDateFromMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="localFilters.unloadingDateFrom"
                  :label="$t('tslOrders.filter.dateFrom')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="localFilters.unloadingDateFrom = null"
                />
              </template>
              <v-date-picker
                v-model="localFilters.unloadingDateFrom"
                @input="unloadingDateFromMenu = false"
                :max="localFilters.unloadingDateTo"
              />
            </v-menu>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu
              v-model="unloadingDateToMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="localFilters.unloadingDateTo"
                  :label="$t('tslOrders.filter.dateTo')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  @click:clear="localFilters.unloadingDateTo = null"
                />
              </template>
              <v-date-picker
                v-model="localFilters.unloadingDateTo"
                @input="unloadingDateToMenu = false"
                :min="localFilters.unloadingDateFrom"
              />
            </v-menu>
          </v-col>
        </v-row>

        <v-divider class="my-4" />

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="localFilters.loadingPlace"
              :label="$t('tslOrders.filter.loadingPlace')"
              outlined
              dense
              clearable
              :hint="$t('tslOrders.filter.loadingPlaceHint')"
              persistent-hint
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="localFilters.unloadingPlace"
              :label="$t('tslOrders.filter.unloadingPlace')"
              outlined
              dense
              clearable
              :hint="$t('tslOrders.filter.unloadingPlaceHint')"
              persistent-hint
            />
          </v-col>
        </v-row>

        <v-divider class="my-4" />

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="localFilters.carrierVatNumber"
              :label="$t('tslOrders.filter.carrierVatNumber')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="localFilters.carrierName"
              :label="$t('tslOrders.filter.carrierName')"
              outlined
              dense
              clearable
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="localFilters.clientVatNumber"
              :label="$t('tslOrders.filter.clientVatNumber')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="localFilters.clientName"
              :label="$t('tslOrders.filter.clientName')"
              outlined
              dense
              clearable
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="localFilters.driverName"
              :label="$t('tslOrders.filter.driverName')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="localFilters.driverPhone"
              :label="$t('tslOrders.filter.driverPhone')"
              outlined
              dense
              clearable
            />
          </v-col>
        </v-row>

        <v-divider class="my-4" />

        <v-row>
          <v-col cols="12">
            <v-autocomplete
              v-model="localFilters.createdByUserId"
              :items="employees"
              item-text="fullName"
              item-value="id"
              :label="$t('tslOrders.filter.createdByEmployee')"
              outlined
              dense
              clearable
              :loading="employeesLoading"
              :search-input.sync="employeeSearch"
            >
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.fullName }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="$emit('close')"
        >
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          depressed
          @click="applyFilters"
        >
          {{ $t('tslOrders.filter.apply') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Service from '@/services'

export default {
  name: 'TSLOrdersFilterDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dateFromMenu: false,
      dateToMenu: false,
      loadingDateFromMenu: false,
      loadingDateToMenu: false,
      unloadingDateFromMenu: false,
      unloadingDateToMenu: false,
      employees: [],
      employeesLoading: false,
      employeeSearch: null,
      localFilters: {
        dateFrom: null,
        dateTo: null,
        carrierVatNumber: '',
        carrierName: '',
        clientVatNumber: '',
        clientName: '',
        driverName: '',
        driverPhone: '',
        loadingDateFrom: null,
        loadingDateTo: null,
        unloadingDateFrom: null,
        unloadingDateTo: null,
        loadingPlace: '',
        unloadingPlace: '',
        createdByUserId: null
      }
    }
  },
  watch: {
    value (val) {
      if (val) {
        this.localFilters = { ...this.filters }
        this.loadEmployees()
      }
    }
  },
  methods: {
    async loadEmployees () {
      this.employeesLoading = true
      try {
        const companyId = this.$store.getters.userCommonData.companyId
        const { data } = await Service.get('/Company/GetCompanyUsers', {
          companyId: companyId
        })
        this.employees = data.map(user => ({
          id: user.id,
          fullName: `${user.name} ${user.surname}`
        }))
      } catch (e) {
        this.$store.dispatch('setErrorNotification', e.response?.data || 'Error loading employees')
      } finally {
        this.employeesLoading = false
      }
    },
    applyFilters () {
      this.$emit('filter', this.localFilters)
    }
  }
}
</script>
